import { FC } from "react";
import Alert from "@mui/material/Alert";
import useBasePath from "src/utils/hooks/useBasePath";
import { LogLevel, useLogStatus } from "src/utils/newRelic/useLogStatus";
import BreadcrumbsMui from "src/Components/BreadcrumbsMui/BreadcrumbsMui";
import { Loader } from "src/Pages/Company/Absences/Loader/Loader";
import __ from "src/utils/Translations";
import { useGetAbsenceType } from "src/Pages/Company/Absences/api/useAbsenceTypes";
import AbsenceTypeForm from "./AbsenceTypeForm/AbsenceTypeForm";

const AbsenceType: FC<{ absenceTypeId?: string }> = ({ absenceTypeId }) => {
  const basePath = useBasePath();
  const logStatus = useLogStatus();

  if (!absenceTypeId) {
    logStatus({
      level: LogLevel.DEBUG,
      message: "No Absence Type ID provided.",
      file: "AbsenceType.tsx",
    });
  }

  const {
    data: absenceTypeData,
    isFetching,
    isSuccess,
    isError,
    error,
  } = useGetAbsenceType(absenceTypeId);

  return (
    <>
      <BreadcrumbsMui
        items={[
          {
            label: __("Nieobecności"),
            to: `${basePath}/absences`,
          },
          {
            label: __("Szablony wniosków"),
            to: `${basePath}/absences/absence-types`,
          },
          {
            label: absenceTypeId
              ? __("Edycja szablonu wniosku")
              : __("Tworzenie nowego szablonu wniosku"),
          },
        ]}
      />
      {absenceTypeId && isFetching && <Loader />}
      {isError && (
        <Alert severity="error">
          {error?.message || __("Nie udało się pobrać danych")}
        </Alert>
      )}
      {(!absenceTypeId || isSuccess) && (
        <AbsenceTypeForm
          absenceTypeId={absenceTypeId}
          absenceTypeData={absenceTypeId ? absenceTypeData : undefined}
          listPath={`${basePath}/absences/absence-types`}
        />
      )}
    </>
  );
};

export default AbsenceType;
